import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-ballot',
  templateUrl: './ballot.component.html',
  styleUrls: ['./ballot.component.scss'],
})
export class BallotComponent implements OnInit {

  @Input() type: string;
  @Input() matrixArray: Array<string>;
  @Input() players: Array<any>;

  @Output() goBack: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output() selectPlayer: EventEmitter<any> = new EventEmitter<any>(false);
  @Output() saveBallot: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  constructor() { }

  ngOnInit() { }

  save() {
    this.saveBallot.emit(true);
  }

}
